import { Box, Button, CircularProgress, DialogContent, FormControlLabel, Modal, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { getInitialValues, validationSchema } from "./FormConfig";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL, SITE_KEY } from "../../Config.js";
import TimezoneSelect from "react-timezone-select"

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};



const IndividualForm = () => {
  const [selectedTimezone, setSelectedTimezone] = useState(null
    // Intl.DateTimeFormat().resolvedOptions().timeZone,
  )
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [recaptcha, setRecaptcha] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);
  const navigate = useNavigate()
  const handleClose = () => {
    setOpen(false);
  }

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    window.recaptchaCallback = function () {
      setRecaptcha(true);
      setRecaptchaError(false);
    };
  }, []);

  const initialValues = getInitialValues();
  const formik = useFormik({
    initialValues,
    validationSchema,

    onSubmit: async (
      values,
      { setErrors, setSubmitting, resetForm, errors }
    ) => {

        if (errors) {
        setErrors(errors);
      }
    //   navigate("/success")

    if (!recaptcha) {
      setRecaptchaError(true);
      return;
    }

    setLoader(true)
    try {
     

        const res = await axios.post(
          `${API_URL}/create/affiliate`,
          {
            name:formik.values.name,
            email:formik.values.email,
            phone:formik.values.phone,
            preferredTime:[[formik.values.date_1,formik.values.time_1],[formik.values.date_2,formik.values.time_2],[formik.values.date_3,formik.values.time_3]],
            type:"2",
            timezone:JSON.stringify(selectedTimezone, null, 2)
          },
          {
            headers: {
            //   "x-access-token": token,
              "Content-Type": "application/json",
            },
          }
        );
        if (res.status === 200) {
          setLoader(false);
          navigate("/success");
          resetForm();
          setRecaptcha(false);
          if (window.grecaptcha) {
            window.grecaptcha.reset();
          }
          console.log(res);
        }
      } catch (err) {
        setLoader(false);
        console.log(err);
      }


    },
  });
  console.log(formik.errors);
  
  const getTextWidth = (text, font = "16px Arial") => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    return context.measureText(text).width;
  };
  const calculateWidth = (text, maxWidth = 600) => {
    const width = Math.max(200, getTextWidth(text || "", "16px Arial") + 10); // Minimum width of 100px
    return width > maxWidth ? maxWidth : width; // Constrain to maxWidth
  };
 

  
  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <Typography
          sx={{
            fontSize: { sm: "25px", xs: "20px" },
            color: "rgba(122, 123, 145, 1)",
            pb: "1.5rem",
          }}
        >
          INDIVIDUAL INFORMATION
        </Typography>
        <Typography
          sx={{
            fontSize: { sm: "25px", xs: "20px" },
            color: "rgba(122, 123, 145, 1)",
            pb: "1.5rem",
          }}
        >
          Your Name:{" "}
          <TextField
            sx={{
              mx: "0.2rem",
              "& input": {
                width: { md: calculateWidth(formik.values.name), xs: "100%" },
                borderBottom:
                    formik.errors.name
                    ? "1px solid red !important"
                    : "1px solid",
              },
            }}
            autoComplete="off"
            variant="standard"
            type="text"
            placeholder=""
            id="name"
            name="name"
            className="bin_2"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />{" "}
        </Typography>
        <Typography
          sx={{
            fontSize: { sm: "25px", xs: "20px" },
            color: "rgba(122, 123, 145, 1)",
            pb: "1.5rem",
          }}
        >
          Your e-mail:{" "}
          <TextField
            sx={{
              mx: "0.2rem",
              "& input": {
                width: { md: calculateWidth(formik.values.email), xs: "100%" },
                borderBottom:
                    formik.errors.email
                    ? "1px solid red !important"
                    : "1px solid",
              },
            }}
            autoComplete="off"
            variant="standard"
            type="email"
            placeholder=""
            id="email"
            name="email"
            className="bin_2"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />{" "}
          Phone:{" "}
          <TextField
            sx={{
              mx: "0.2rem",
              "& input": {
                width: { md: calculateWidth(formik.values.phone), xs: "100%" },
                borderBottom:
                    formik.errors.phone
                    ? "1px solid red !important"
                    : "1px solid",
              },
            }}
            autoComplete="off"
            variant="standard"
            type="text"
            placeholder=""
            id="phone"
            name="phone"
            className="bin_2"
            value={formik.values.phone}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />{" "}
        </Typography>
        <Typography
          sx={{
            fontSize: { sm: "25px", xs: "20px" },
            color: "rgba(122, 123, 145, 1)",
            pb: "1.5rem",
          }}
        >
          Prefered times and days to reach you:{" "}
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: { sm: "1rem", xs: "1rem" },
            pb: "1.5rem",
            // flexWrap:"wrap"
            "& p": {
              fontSize: { sm: "25px", xs: "20px" },
              color: "rgba(122, 123, 145, 1)",
            },
          }}
        >
          <Typography>
            Date:
            <TextField
              sx={{
                mx: "0.2rem",
                "& input": {
                  width: {
                    md: calculateWidth(formik.values.date_1),
                    xs: "100%",
                  },
                  borderBottom:
                      formik.errors.date_1
                      ? "1px solid red !important"
                      : "1px solid",
                },
              }}
              autoComplete="off"
              variant="standard"
              type="text"
              placeholder=""
              id="date_1"
              name="date_1"
              className="bin_2"
              value={formik.values.date_1}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />{" "}
          </Typography>
          <Typography>
            <RadioGroup
              row
              name="time_1"
              value={formik.values.time_1}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{
                "& span": {
                  fontSize: { sm: "19px", xs: "19px" },
                  fontFamily: "myriadRegular !important",
                  lineHeight: "0 !important",
                },
              }}
            >
              <FormControlLabel
                value="morning"
                control={<Radio disableRipple />}
                label="Morning"
                sx={{
                  "& .MuiRadio-root": {
                    color:
                        formik.errors.time_1
                        ? "red"
                        : "inherit",
                  },
                }}
              />
              <FormControlLabel
                value="afternoon"
                control={<Radio disableRipple />}
                label="Afternoon"
                sx={{
                  "& .MuiRadio-root": {
                    color:
                        formik.errors.time_1
                        ? "red"
                        : "inherit",
                  },
                }}
              />
              <FormControlLabel
                value="evening"
                control={<Radio disableRipple />}
                label="Evening"
                sx={{
                  mr: "0 !important",
                  "& .MuiRadio-root": {
                    color:
                      formik.errors.time_1
                        ? "red"
                        : "inherit",
                  },
                }}
              />
            </RadioGroup>
          </Typography>
          <Typography
            sx={{
              opacity: "0.3",
            }}
          >
            (Required)
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: { sm: "1rem", xs: "1rem" },
            pb: "1.5rem",
            // flexWrap:"wrap"
            "& p": {
              fontSize: { sm: "25px", xs: "20px" },
              color: "rgba(122, 123, 145, 1)",
            },
          }}
        >
          <Typography>
            Date:
            <TextField
              sx={{
                mx: "0.2rem",
                "& input": {
                  width: {
                    md: calculateWidth(formik.values.date_2),
                    xs: "100%",
                  },
                },
              }}
              autoComplete="off"
              variant="standard"
              type="text"
              placeholder=""
              id="date_2"
              name="date_2"
              className="bin_2"
              value={formik.values.date_2}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />{" "}
          </Typography>
          <Typography>
            <RadioGroup
              row
              name="time_2"
              value={formik.values.time_2}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{
                "& span": {
                  fontSize: { sm: "19px", xs: "19px" },
                  fontFamily: "myriadRegular !important",
                  lineHeight: "0 !important",
                },
              }}
            >
              <FormControlLabel
                value="morning"
                control={<Radio disableRipple />}
                label="Morning"
                sx={{
                  "& .MuiRadio-root": {
                    color:
                        formik.errors.time_2
                        ? "red"
                        : "inherit",
                  },
                }}
              />
              <FormControlLabel
                value="afternoon"
                control={<Radio disableRipple />}
                label="Afternoon"
                sx={{
                  "& .MuiRadio-root": {
                    color:
                        formik.errors.time_2
                        ? "red"
                        : "inherit",
                  },
                }}
              />
              <FormControlLabel
                value="evening"
                control={<Radio disableRipple />}
                label="Evening"
                sx={{
                  mr: "0 !important",
                  "& .MuiRadio-root": {
                    color:
                        formik.errors.time_2
                        ? "red"
                        : "inherit",
                  },
                }}
              />
            </RadioGroup>
          </Typography>
          <Typography
            sx={{
              opacity: "0.3",
            }}
          >
            (Optional)
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: { sm: "1rem", xs: "1rem" },
            pb: "1.5rem",
            // flexWrap:"wrap"
            "& p": {
              fontSize: { sm: "25px", xs: "20px" },
              color: "rgba(122, 123, 145, 1)",
            },
          }}
        >
          <Typography>
            Date:
            <TextField
              sx={{
                mx: "0.2rem",
                "& input": {
                  width: {
                    md: calculateWidth(formik.values.date_3),
                    xs: "100%",
                  },
                },
              }}
              autoComplete="off"
              variant="standard"
              type="text"
              placeholder=""
              id="date_3"
              name="date_3"
              className="bin_2"
              value={formik.values.date_3}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />{" "}
          </Typography>
          <Typography>
            <RadioGroup
              row
              name="time_3"
              value={formik.values.time_3}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{
                "& span": {
                  fontSize: { sm: "19px", xs: "19px" },
                  fontFamily: "myriadRegular !important",
                  lineHeight: "0 !important",
                },
              }}
            >
              <FormControlLabel
                value="morning"
                control={<Radio disableRipple />}
                label="Morning"
                sx={{
                  "& .MuiRadio-root": {
                    color:
                       formik.errors.time_3
                        ? "red"
                        : "inherit",
                  },
                }}
              />
              <FormControlLabel
                value="afternoon"
                control={<Radio disableRipple />}
                label="Afternoon"
                sx={{
                  "& .MuiRadio-root": {
                    color:
                       formik.errors.time_3
                        ? "red"
                        : "inherit",
                  },
                }}
              />
              <FormControlLabel
                value="evening"
                control={<Radio disableRipple />}
                label="Evening"
                sx={{
                  mr: "0 !important",
                  "& .MuiRadio-root": {
                    color:
                      formik.errors.time_3
                        ? "red"
                        : "inherit",
                  },
                }}
              />
            </RadioGroup>
          </Typography>
          <Typography
            sx={{
              opacity: "0.3",
            }}
          >
            (Optional)
          </Typography>
        </Box>
      <Typography sx={{
        width:{sm:"50%",xs:"100%"},
        pb:"1.5rem"
      }}>
       Timezone:{" "}
        <TimezoneSelect value={selectedTimezone} onChange={setSelectedTimezone} />
      </Typography>

        <Box
          sx={{
            mt: "1rem",
          }}
          className="g-recaptcha"
          data-sitekey={SITE_KEY}
          data-callback="recaptchaCallback"
        ></Box>
        {!recaptcha && recaptchaError && (
          <Typography sx={{ fontSize: "14px", color: "red", mt: "0.5rem" }}>
            Please tick above recaptcha.
          </Typography>
        )}

        <Button
          // type="submit"
          className="btn"
          sx={{
            mt: "2rem",
            mb: "2rem",
            border: "1px solid rgba(121, 123, 145, 1)",
            color: "rgba(121, 123, 145, 1) !important",
            fontWeight: "600 !important",
            width: loader ?"150px !important":"auto !important",
          }}
          onClick={() => {
            formik.validateForm().then((errors) => {
              if (!recaptcha) {
                setRecaptchaError(true);
                return;
              }
              if (Object.keys(errors).length === 0) {
                setOpen(true);
              }
            });
          }
           }
        >
           
                 Submit Inquiry
          
        </Button>
      <Box
              sx={{
                "& p": {
                  fontSize: "14px",
                  color: "red",
                },
              }}
            >
              { formik.errors.name && (
                <Typography>{formik.errors.name}</Typography>
              )}
              {formik.errors.email && (
                <Typography>{formik.errors.email}</Typography>
              )}
              { formik.errors.phone && (
                <Typography>{formik.errors.phone}</Typography>
              )}
              { formik.errors.preferredTime && (
                <Typography>{formik.errors.preferredTime}</Typography>
              )}
              { formik.errors.date_1 && (
                <Typography>{formik.errors.date_1}</Typography>
              )}
              {formik.errors.time_1 && (
                <Typography>{formik.errors.time_1}</Typography>
              )}
           
            </Box>
              <Modal open={open}   onClose={handleClose} aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description" >
                <Box sx={style}>
                  <p>When you submit your contact information through this form, we collect the following categories of personal information:</p>
                  <p>Identifiers including your name, email address, phone number, and time zone.</p>
                  <p>We collect this information for the purpose of responding to your inquiry and providing customer service. Your personal information may be shared internally within our company, including other departments or personnel who manage customer communications, such as, forwarding your submitted information to our service email address under the same ownership. We do not share your information with external third parties without your consent.</p><p>For more details on how we collect, use, and protect your information, please review our <a href="https://www.capnolearning.org/privacy-policy" target="_blank" >Privacy Policy</a>.</p>
                 <Button
          // type="submit"
          onClick={() => formik.handleSubmit()}
          className="btn"
          sx={{
            mt: "2rem",
            mb: "2rem",
            border: "1px solid rgba(121, 123, 145, 1)",
            color: "rgba(121, 123, 145, 1) !important",
            fontWeight: "600 !important",
            width: loader ?"150px !important":"auto !important",
          }}>
                   {loader ? (
                  <CircularProgress
                    sx={{
                      width: "16px !important",
                      height: "16px !important",
                      color: "#000 !important",
                    }}
                  />
                ) : (
                  "Agree & Send Inquiry"
                )}
                </Button>
               </Box>
              </Modal>
      </form>

      
    </div>
  );
};

export default IndividualForm;
